<template>
  <div class="staging-auth">
    <div class="staging-auth__content">
      <div class="staging-auth__input-wrapper">
          <div class="staging-auth__eye">
              <basic-input v-model="password"
                           name="password"
                           label="Password"
                           :type="passwordVisible ? 'text' : 'password'"
                           class="staging-auth__input"
                           :validators="[]"
                           :initialStatus="inputStatus('password')"
                           :initialErrorMessages="inputErrors('password')"
                           @confirm="signIn"/>
              <i :class="['far', passwordVisible ? 'fa-eye-slash' : 'fa-eye']" @click="toggleVisibility"/>
          </div>
      </div>
      <div class="btn inverted staging-auth__btn" @click="signIn">SIGN IN</div>
    </div>
  </div>
</template>

<script>
import BasicInput from '@/../shared/components/BasicInput'
import { mapActions } from 'vuex'

export default {
  name: 'StagingAuth',
  components: {
    BasicInput
  },
  data () {
    return {
      password: '',
      passwordVisible: false,
      errors: {}
    }
  },
  methods: {
    ...mapActions('auth', ['stagingSignIn']),
    async signIn () {
      this.clearErrors()
      let result = await this.stagingSignIn(this.password)

      if (!result) {
        this.$set(this.errors, 'password', ['is invalid'])
        return
      }

      let redirect = this.$store.getters['globalData/getRedirectTo']

      if (redirect) {
        this.$store.dispatch('globalData/clearRedirectTo')
        this.$router.push({
          name: redirect.name,
          params: redirect.params,
          query: redirect.query
        })
      } else {
        this.$router.push({ name: 'index' })
      }
    },
    clearErrors () {
      this.errors = {}
    },
    inputErrors (field) {
      return (this.errors && this.errors[field]) || []
    },
    inputStatus (field) {
      return this.inputErrors(field).length > 0 ? 'error' : ''
    },
    toggleVisibility() {
      this.passwordVisible = !this.passwordVisible
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/stylesheets/variables.scss';

  .staging-auth {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 40px);
    width: 100vw;
    overflow: hidden;

    &__content {
      background: $color-gray-lighter;
      height: 300px;
      width: 500px;
      display: grid;
      grid-row-gap: 30px;
      align-content: center;
      justify-content: center;
    }

    &__input-wrapper {
      display: grid;
      grid-row-gap: 18px;
    }

    &__eye {
      position: relative;
      i {
        position: absolute;
        top: 30px;
        right: 30px;
        font-size: 2rem;
        cursor: pointer;
      }
    }

    &__input {
      ::v-deep input {
        background: $color-white !important;
      }
    }
  }
</style>
